export default __webpack_public_path__ + "static/media/slapenautoKlein.899254e9.jpg";